<template>
  <section
    class="hr-section hr-quick"
    :aria-labelledby="showTitle ? 'hr-quick-title' : null"
    :aria-label="showTitle ? null : 'Быстрые ссылки'"
  >
    <div class="hr-container">
      <div class="hr-quick__card">
        <h2 v-if="showTitle" id="hr-quick-title" class="hr-section-title">Часто ищут</h2>
        <ul class="hr-quick__grid">
          <li v-for="item in items" :key="item.label">
            <router-link class="hr-quick__item" :to="item.to">
              <span class="hr-quick__icon"><HrIcon :name="item.icon" :image="item.iconImage" /></span>
              <span class="hr-quick__label">{{ item.label }}</span>
              <span class="hr-quick__arrow" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import HrIcon from './HrIcon.vue'

export default {
  name: 'HrQuickLinks',
  components: { HrIcon },
  props: {
    items: { type: Array, required: true },
    showTitle: { type: Boolean, default: true },
  },
}
</script>
